import {UserLevel} from '@netx/core-user/constants';

export const ASSET_DOWNLOAD_MINUMUM_USER_LEVEL = UserLevel.CONSUMER;
export const ASSET_RESYNC_MINIMUM_USER_LEVEL = UserLevel.PRODUCER;

export enum AssetPref {
	CHECKSUM_ENABLED = 'metadata.checksumEnabled',
}
